<template>
  <div :style="[styles.container, containerStyle]" @click.stop="change">
    <div :style="activeStyle"></div>
    <span :style="[basicStyle, {color: (status ? '#4C4C4C': color)}]">
      {{ checkedText }}
    </span>
    <span :style="[basicStyle, {color: (!status ? '#4C4C4C' : color)}]">
      {{ unCheckedText }}
    </span>
  </div>
</template>

<script>
import StyleSheet, { calcNum } from '../StyleSheet';

const SIZE = {
  small: 10,
  default: 12,
};

const HEIGHT = {
  small: 20,
  default: 25,
};

const LINEHEIGHT = {
  small: 20,
  default: 25,
};

const RADIUS = {
  small: 10,
  default: 15,
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default {
  name: 'HySwitch',
  props: {
    size: { // 字体大小
      type: String,
      default: 'default',
      isRequired: false,
      validator: (val) => ['default', 'small'].includes(val),
    },
    color: {
      type: String,
      default: '#999999',
      isRequired: false,
    },
    checkedText: {
      type: String,
      default: '是',
      isRequired: false,
    },
    unCheckedText: {
      type: String,
      default: '否',
      isRequired: false,
    },
    checkedBackgroundColor: {
      type: String,
      default: '#FFFFFF',
      isRequired: false,
    },
    fontWeight: {
      type: [Number, String],
      default: '400',
    },
    lineHeight: {
      type: [Number, String],
      default: 25,
    },
    width: {
      type: [Number, String],
      default: 82,
    },
    height: {
      type: [Number, String],
      default: 25,
    },
    defaultChecked: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      styles,
      status: this.defaultChecked || true,
    };
  },
  computed: {
    containerStyle() {
      return {
        width: calcNum(this.width),
        height: calcNum(HEIGHT[this.size]) || this.height,
        color: this.color,
        backgroundColor: '#F2F2F2',
        borderRadius: calcNum(RADIUS[this.size]),
      };
    },
    basicStyle: {
      get() {
        const parentHeight = HEIGHT[this.size] || this.height;
        const parentWidth = this.width;
        const style = {
          fontSize: calcNum(SIZE[this.size]),
          color: this.color,
          textAlign: 'center',
          borderRadius: calcNum(RADIUS[this.size]),
          marginLeft: 9,
          marginRight: 9,
          height: calcNum(parentHeight),
          width: calcNum((parentWidth - 2) / 3),
          lineHeight: calcNum(LINEHEIGHT[this.size] || this.lineHeight),
        };
        return style;
      },
    },
    activeStyle: {
      get() {
        const parentHeight = HEIGHT[this.size] || this.height;
        const parentWidth = this.width;
        const style = {
          position: 'absolute',
          backgroundColor: this.checkedBackgroundColor,
          borderRadius: calcNum(RADIUS[this.size]),
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1,
          top: 0,
          height: calcNum(parentHeight - 2),
          width: calcNum((parentWidth - 2) / 2),
          left: (this.status ? 0 : calcNum((parentWidth - 2) / 2)),
        };
        return style;
      },
    },
  },
  methods: {
    change() {
      this.status = !this.status;
      this.$emit('change', this.status);
    },
  },
};
</script>
